<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">



      <div class="grid-menu grid-menu-2col" v-if="activityOptions.length > 0">
        <div class="no-gutters row">


          <div class="col-sm-4" v-for="item in userAuth.relationPages.filter(a => a.accessGeneral)" :key="item.pageRelationId">

            <t-button v-show="item.accessGeneral" class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :to="item.name">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
             {{ item.pageTitle}}
            </t-button>
          </div>

        </div>


      </div>

      <t-msg v-else-if="pageIsLoaded" info>Atividades são formulários adicionais que podem ser vinculados a um modelo de inspeção. No
        momento não há nenhuma atividade habilitada na sua conta, caso desejar habilitar por favor entre em contato com a
        Onlaine para saber mais.
      </t-msg>


    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import TypeChecklistActivityService from "@/services/modules/checklist/TypeChecklistActivity.service";

export default {
  mixins: [pageDefaultMixin],
  name: 'TypeActivity',
  data() {
    return {
      activityOptions:[],
      pageIsLoaded:false,
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      await TypeChecklistActivityService.selectList().then((list) => {
        this.activityOptions = list
      }).catch(error => this.responseError(error))

      this.pageIsLoaded = true

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
